import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class NewAggregationService {

  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }

  /**
   * realiza una conexion de nuevo
   * @param token: string
   */
  addNewAccount(): Observable<any> {
    return this.http.get<any>(environment.url + '/Tink/NewAggregation',
    { headers: this.headers.set('Authorization', sessionStorage.getItem('t')) }).pipe(retry(1), catchError(this.errorHandl));
  }

  /**
   * Control errores generico para todas las llamadas
   * @param error: Object
   */
  errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
